module.exports = __webpack_public_path__ + "img/sjd.7760ff50.png";